var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideDesignImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 422,
    viewBox: "0 0 358 422",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 286.155,
    height: 17.4014,
    rx: 3,
    transform: "matrix(0.990268 -0.139173 0.190809 0.981627 22.2422 154.533)",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 286.155,
    height: 98.7579,
    rx: 3,
    transform: "matrix(0.990268 -0.139173 0.190809 0.981627 0.0859375 40.5547)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 221.487,
    height: 17.4014,
    rx: 3,
    transform: "matrix(0.990268 -0.139173 0.190809 0.981627 26.9824 178.923)",
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 62.1738,
    height: 17.4014,
    rx: 3,
    transform: "matrix(0.990268 -0.139173 0.190809 0.981627 31.7227 203.314)",
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 0.590539,
    y: 0.421227,
    width: 61.1738,
    height: 16.4014,
    rx: 2.5,
    transform: "matrix(0.990268 -0.139173 0.190809 0.981627 98.4801 194.012)",
    stroke: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 286.155,
    height: 17.4014,
    rx: 3,
    transform: "matrix(0.990268 -0.139173 0.190809 0.981627 61.2891 355.408)",
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 286.155,
    height: 98.7579,
    rx: 3,
    transform: "matrix(0.990268 -0.139173 0.190809 0.981627 39.1328 241.43)",
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 221.487,
    height: 17.4014,
    rx: 3,
    transform: "matrix(0.990268 -0.139173 0.190809 0.981627 66.0293 379.798)",
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 62.1738,
    height: 17.4014,
    rx: 3,
    transform: "matrix(0.990268 -0.139173 0.190809 0.981627 70.7695 404.189)",
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 0.590539,
    y: 0.421227,
    width: 61.1738,
    height: 16.4014,
    rx: 2.5,
    transform: "matrix(0.990268 -0.139173 0.190809 0.981627 137.527 394.887)",
    stroke: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideDesignImg);
export default __webpack_public_path__ + "static/media/sideDesignImg.1c307b6bf39fc88ef37247bab79214bb.svg";
export { ForwardRef as ReactComponent };